import React, { useState, useEffect } from 'react';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenu(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <ul className="nav-links">
          <li><button onClick={() => scrollToSection('hero')}>🏠 Home</button></li>
          <li><button onClick={() => scrollToSection('about')}>ℹ️ About</button></li>
          <li><button onClick={() => scrollToSection('principal')}>👨‍🏫 Principal</button></li>
          <li><button onClick={() => scrollToSection('courses')}>📚 Courses</button></li>
          <li><button onClick={() => scrollToSection('achievements')}>🏆 Achievements</button></li>
          <li><button onClick={() => scrollToSection('events')}>📅 Events</button></li>
          <li><button onClick={() => scrollToSection('placement')}>💼 Placement</button></li>
          <li><button onClick={() => scrollToSection('gallery')}>🖼️ Gallery</button></li>
          <li><button onClick={() => scrollToSection('contact')}>📞 Contact</button></li>
        </ul>
        <button className="mobile-menu-btn" onClick={() => setMobileMenu(!mobileMenu)}>
          {mobileMenu ? '✕' : '☰'}
        </button>
      </div>
      {mobileMenu && (
        <ul className="mobile-nav">
            <li><button onClick={() => scrollToSection('hero')}>🏠 Home</button></li>
            <li><button onClick={() => scrollToSection('about')}>ℹ️ About</button></li>
            <li><button onClick={() => scrollToSection('principal')}>👨‍🏫 Principal</button></li>
            <li><button onClick={() => scrollToSection('courses')}>📚 Courses</button></li>
            <li><button onClick={() => scrollToSection('achievements')}>🏆 Achievements</button></li>
            <li><button onClick={() => scrollToSection('events')}>📅 Events</button></li>
            <li><button onClick={() => scrollToSection('placement')}>💼 Placement</button></li>
            <li><button onClick={() => scrollToSection('gallery')}>🖼️ Gallery</button></li>
            <li><button onClick={() => scrollToSection('contact')}>📞 Contact</button></li>
        </ul>
      )}
    </nav>
  );
}

export default Navbar;